/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // :: show multiple images for variant selection on variant change ::
  document.addEventListener('theme:variant:change', (e) => {
    const productComponent = e.target.closest('product-component') || e.target;
    const productImages = productComponent?.querySelector('product-images');
    const productHandle = productImages?.getAttribute('handle');
    const sectionId = productImages?.getAttribute('section-id');
    const variantId = e?.detail?.variant?.id;
    if (!productImages || !productHandle || !variantId) return;

    fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(productHandle)}?variant=${encodeURIComponent(variantId)}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((data) => {
        const html = new DOMParser().parseFromString(data, 'text/html');
        const productImagesDestination = html.querySelector('product-images');
        if (productImagesDestination) productImages.replaceWith(productImagesDestination);
      })
      .catch((error) => console.error('Failed to update product images after variant change:', error));
  });

  // custom navigation item style
  // const navItems = document.querySelectorAll('.drawer__main-menu > .mobile__menu__item__parent');
  
  // Array.from(navItems).forEach(item => {
  //   if (item !== null) {
  //     // Remove 'active' class from all items
  //     navItems.forEach(navItem => navItem.classList.remove('active'));

  //     const sliderowBack = item.querySelector('.sliderow.sliderow--back')

  //     if (sliderowBack !== null) {
  //       // Stop event propagation when arrow is clicked
  //       sliderowBack.addEventListener('click', (e) => {
  //         e.stopPropagation();

  //         // Remove 'active' class from this item
  //         item.classList.remove('active');

  //         item.parentElement.classList.remove('one-item-active');
  //       });
  //     }
    
  //     item.addEventListener('click', (e) => {
  //       // Remove 'active' class from all items
  //       navItems.forEach(navItem => navItem.classList.remove('active'));
        
  //       // Add 'active' class to clicked item
  //       item.classList.add('active');

  //       item.parentElement.classList.add('one-item-active');
  //     })
  //   }
  // })


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
